export interface MenuControllerState {
    contextOpen : boolean;
    sideMenuOpen : boolean;
    contextKey : number;
    recentItems : Array<SearchItemType>;
    isMaintenance: boolean;
}

export type SearchItemType = {
    type : "default" | "custom";
    title : string;
    target : string;
    values : Array<string>;
    url? : string;
    description : string;
}

export const UPDATE_CONTEXT_MENU = "UPDATE_CONTEXT_MENU";
export const UPDATE_SIDE_MENU = "UPDATE_SIDE_MENU";
export const UPDATE_KEY = "UPDATE_KEY";
export const ADD_RECENT_ITEM = "ADD_RECENT_ITEM";
export const TOGGLE_MAINTENANCE = "TOGGLE_MAINTENANCE";

interface toggleMaintenance {
    type: typeof TOGGLE_MAINTENANCE;
    payload: boolean;
}

interface AddSearchItem {
    type : typeof ADD_RECENT_ITEM;
    payload : SearchItemType;
}

interface UpdateContextMenuAction {
    type : typeof UPDATE_CONTEXT_MENU;
    payload: boolean;
}

interface UpdateSideMenuAction {
    type : typeof UPDATE_SIDE_MENU;
    payload : boolean;
}

interface UpdateKey {
    type: typeof UPDATE_KEY;
}

export type MenuControllerTypes = UpdateContextMenuAction | 
UpdateSideMenuAction | 
UpdateKey |
AddSearchItem |
toggleMaintenance;